var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",class:_vm.theme},[(!_vm.isApp)?[_c('ClientHeader',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHeader),expression:"showHeader"}],attrs:{"show":_vm.showHeader}})]:_vm._e(),_c('router-view'),(!_vm.isApp)?[(!_vm.hideFooter)?_c('Footer'):_vm._e(),_c('MobileFooter')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }